var core = require("./EHcore.js");
var Calcu_02 = core.Calcu_02
var Calcu_04 = core.Calcu_04
var Calcu_24 = core.Calcu_24
var Calcu_25 = core.Calcu_25
var Calcu_45 = core.Calcu_45
var Chart = function (configure) {
	//画布大小
	this.width = configure.width;
	this.height = configure.height;

	//定义新原点
	this.origin_x = this.width * 5 / 80,
		this.origin_y = this.height * 5 / 6;

	//配置
	this.toolTipsParm = { StrokeColor: 'rgba(100,10,10,0.9)', TextColor: 'black' };

	//物理参数及外观配置
	var fontSzie = this.width * 10 / 800;
	this.font = fontSzie + 'px Arial';
	this.textcolor = 'black';

	this.temperatureParm = configure.temperatureParm || { l: -10, h: 50, StrokeColor: '#FF0033' };//温度范围
	this.dampnessParm = configure.dampnessParm || { l: 0, h: 40, StrokeColor: '#337ab7' };//湿度配置
	this.enthalpyParm = configure.enthalpyParm || { l: -20, h: 140, StrokeColor: 'rgba(170,81,24,0.5)' };//焓值范围
	this.RhParm = configure.RhParm || { StrokeColor: 'rgba(10,10,10,0.5)' }
	this.atm = configure.atm || 101.325;//kPa

	//定义比例系数
	this.scale_d = this.width * 700 / 800 / 40;
	this.scale_h = this.height * 370 / 600 / 60;

	//焓湿图边界点坐标
	this.BorderPoints = [];

	//送风处理
	this.project = {};
	this.ini();
}
Chart.prototype = {
	//生成画布背景
	ini: function () {
		//创建一个缓冲画布
		this.backBuffer = document.createElement('canvas');
		this.backBuffer.width = this.width;
		this.backBuffer.height = this.height;
		this.backBufferctx = this.backBuffer.getContext('2d');
		this.drawMark(this.backBufferctx);//绘制标注(大气压值)
		this.drawTemperature(this.backBufferctx);//绘制温度
		this.drawDampness(this.backBufferctx);//绘制湿度
		this.drawRH(this.backBufferctx);//绘制相对湿度
		this.drawEnthalpy(this.backBufferctx);//绘制焓值
		this.drawClip(this.backBufferctx);//描边
	},
	//绘制提示工具
	drawToolTip: function (ctx, x, y, strokecolor, textcolor) {
		var isInClip = this.isInClip(ctx, { x: x, y: y });
		if (!isInClip) return false;

		var res = this.xy2res(x, y);//注意，此处的d单位为g/kg

		//等温线
		var Tpoints = this.T2Points(res.t);
		var Twpoints = this.T2Points(res.tw);//湿球温度
		var Tdpoints = this.T2Points(res.td);//露点温度

		//等焓值线
		var Epoints = this.H2points(res.h);

		//等湿度线
		var Dpoints = this.D2points(res.d * 1000);

		//等相对湿度线
		var RHpoints = this.RH2points(res.rh);
		ctx.lineWidth = 1;
		ctx.strokeStyle = strokecolor || this.toolTipsParm.StrokeColor;
		ctx.save();
		this.createClip(ctx);//定义绘制范围

		ctx.drawDashLine(Tpoints.p1.x, Tpoints.p1.y, x, y);
		ctx.drawDashLine(Twpoints.p1.x, Twpoints.p1.y, Twpoints.p2.x, Twpoints.p2.y);
		ctx.drawDashLine(Tdpoints.p1.x, Tdpoints.p1.y, Tdpoints.p2.x, Tdpoints.p2.y);
		ctx.drawDashLine(x, y, Epoints.p2.x, Epoints.p2.y);
		ctx.drawDashLine(Dpoints.p1.x, Dpoints.p1.y, Dpoints.p2.x, Dpoints.p2.y);

		ctx.beginPath();
		var isFirstP = false;
		ctx.moveTo(x, y);
		RHpoints.forEach(function (p, i) {
			if (x < p.x && y > p.y) {
				ctx.lineTo(p.x, p.y);
			}
		});
		ctx.stroke();
		ctx.restore();
		//标注
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		ctx.strokeStyle = textcolor || this.toolTipsParm.TextColor;
		ctx.font = this.font;

		ctx.strokeText(res.t.toFixed(2), (x + Tpoints.p1.x) / 2, y);
		if (!isNaN(res.tw)) res.tw = res.tw.toFixed(2);
		ctx.strokeText(res.tw, (Twpoints.p1.x + x) / 2, (Twpoints.p1.y + Twpoints.p2.y) / 2);
		if (!isNaN(res.td)) res.td = res.td.toFixed(2);
		ctx.strokeText(res.td, (Tdpoints.p1.x + x) / 2, (Tdpoints.p1.y + Tdpoints.p2.y) / 2);
		ctx.strokeText(res.h.toFixed(2), x + 30, y + 30);
		ctx.strokeText((res.d * 1000).toFixed(2), x, y - 60);
		if (!isNaN(res.rh)) res.rh = res.rh.toFixed(2);
		ctx.strokeText(res.rh, x + 60, y - 60);

		//绘制鼠标中心点
		ctx.beginPath();
		ctx.arc(x, y, 2, 0, 2 * Math.PI);
		ctx.stroke();
		//console.log("res:",res)
		return res;
	},
	//得到在范围内的结果
	getRes: function (ctx, x, y) {
		var isInClip = this.isInClip(ctx, { x: x, y: y });
		if (!isInClip) {
			return false;
		}
		return this.xy2res(x, y);//注意，此处的d单位为g/kg
	},
	//
	createImg: function () {
		var img = new Image();
		img.src = this.backBuffer.toDataURL();//TODO:保存为图片……
		//测试用
		//var c1=document.getElementById("canvas_wrapper");
		//c1.append(this.backBuffer);
		return img;
	},
	getImgData: function () {
		var imgData = this.backBufferctx.getImageData(0, 0, this.width, this.height);
		return imgData;
	},
	createClip: function (ctx) {
		var p1 = { x: 0, y: 0 }, p2 = { x: 0, y: 0 }, p3 = { x: 0, y: 0 }, p4 = { x: 0, y: 0 }, p5 = { x: 0, y: 0 };
		//==0获取一下
		if (this.BorderPoints.length == 0) {
			var res1 = Calcu_04(this.temperatureParm.h, 0, this.atm);
			p1.x = this.d2x(0);
			p1.y = this.dh2y(0, res1.h) - 10;
			p2.x = this.d2x(this.dampnessParm.h);
			p2.y = p1.y;

			var res2 = Calcu_24(100, this.dampnessParm.h / 1000, this.atm);
			p3.x = p2.x;
			p3.y = this.dh2y(this.dampnessParm.h, res2.h);
			//console.log("p3:",p3,res2)
			var res3 = Calcu_02(this.temperatureParm.l, 100, this.atm);
			p4.x = this.d2x(res3.d * 1000);
			p4.y = this.dh2y(res3.d * 1000, res3.h);
			var res4 = Calcu_04(this.temperatureParm.l, 0, this.atm);
			p5.x = p1.x;
			p5.y = this.dh2y(0, res4.h);

			//绘制最后一条路径时，获取路径，用于边界
			for (var d = 2.001; d <= this.dampnessParm.h + 0.001; d = d + 2) {
				var result = Calcu_24(100, d / 1000, this.atm);
				var x = this.d2x(d);;
				var y = this.dh2y(d, result.h);
				this.BorderPoints.push({ x: x, y: y })
			}
			this.BorderPoints.push(p3);
			this.BorderPoints.push(p2);
			this.BorderPoints.push(p1);
			this.BorderPoints.push(p5);
			this.BorderPoints.push(p4);
			//line-3-2-1-5-4
		}
		//创建路径clip
		ctx.beginPath();
		this.BorderPoints.forEach(function (p) { ctx.lineTo(p.x, p.y); });
		ctx.closePath()
		ctx.clip();
	},
	isInClip: function (ctx, p) {
		ctx.beginPath();
		this.BorderPoints.forEach(function (p) { ctx.lineTo(p.x, p.y); });
		ctx.closePath()
		return ctx.isPointInPath(p.x, p.y)
	},
	drawClip: function (ctx) {
		ctx.lineWidth = 2;
		ctx.strokeStyle = "black";
		ctx.beginPath();
		this.BorderPoints.forEach(function (p) { ctx.lineTo(p.x, p.y); });
		ctx.closePath()
		ctx.stroke();
	},
	drawTemperature: function (ctx) {
		var x1, y1, x2, y2, x3, y3;
		ctx.textAlign = "right";
		ctx.textBaseline = "middle";
		for (var t = this.temperatureParm.l; t <= this.temperatureParm.h; t++) {
			ctx.lineWidth = 1;
			var points = this.T2Points(t);
			//将d,h映射到x,y上
			x1 = points.p1.x;
			y1 = points.p1.y;

			x2 = points.p2.x;
			y2 = points.p2.y;

			x3 = points.p3.x;
			y3 = points.p3.y;
			//绘制标注
			if (t % 5 == 0) {
				ctx.font = this.font;
				ctx.strokeStyle = this.textcolor;
				ctx.strokeText(t + "℃", x3, y3);
				ctx.lineWidth = 2;
			}
			if (t % 1 == 0) {
				//重新定义绘制范围时，先保存下
				ctx.save();
				this.createClip(ctx);//定义绘制范围
				//绘制线
				ctx.strokeStyle = this.temperatureParm.StrokeColor;
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
				//恢复定义的绘制范围
				ctx.restore();
			}
		}
	},
	drawEnthalpy: function (ctx) {
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		var x1, y1, x2, y2, x3, y3;
		for (var h = this.enthalpyParm.l; h <= this.enthalpyParm.h; h++) {
			ctx.lineWidth = 1;
			var points = this.H2points(h);
			//将d,h映射到x,y上
			x1 = points.p1.x;
			y1 = points.p1.y;

			x2 = points.p2.x;
			y2 = points.p2.y;
			ctx.save();
			this.createClip(ctx);//定义绘制范围
			if (h % 10 == 0) {
				ctx.lineWidth = 2;
			}
			if (h % 2 == 0) {
				//绘制xian			
				ctx.strokeStyle = this.enthalpyParm.StrokeColor;
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
			//重新定义绘制范围时，先保存下
			if (h % 10 == 0) {
				//绘制标注
				ctx.lineWidth = 1;
				x3 = points.p3.x;
				y3 = points.p3.y;
				ctx.font = this.font
				ctx.strokeStyle = this.textcolor;
				ctx.strokeText(h, x3, y3);
			}
			//标注绘制在了绘图区域内
			ctx.restore();
		}
	},
	drawRH: function (ctx) {
		var points;
		var x1, y1, x2, y2, x3, y3;
		for (var rh = 0; rh <= 100; rh = rh + 10) {
			ctx.lineWidth = 1;
			//重新定义绘制范围时，先保存下
			ctx.save();
			this.createClip(ctx);//定义绘制范围
			ctx.strokeStyle = this.RhParm.StrokeColor;
			ctx.beginPath();
			points = this.RH2points(rh);//获取该线的序列点
			points.forEach(function (p) { ctx.lineTo(p.x, p.y); });

			ctx.stroke();
			ctx.restore();
			//这里是标注
		}
	},
	drawDampness: function (ctx) {
		var x, x2, y, y2, res1, res2;
		res1 = Calcu_04(this.temperatureParm.h, 0, this.atm);
		res2 = Calcu_04(this.temperatureParm.l, 0, this.atm);
		y = this.dh2y(0, res1.h) - 10;
		y2 = this.dh2y(0, res2.h) - 10;

		//横线
		ctx.lineWidth = 2;
		ctx.strokeStyle = this.dampnessParm.StrokeColor;
		ctx.beginPath();
		ctx.moveTo(this.d2x(0), y);
		ctx.lineTo(this.d2x(this.dampnessParm.h), y);
		ctx.stroke();

		ctx.lineWidth = 1;
		ctx.textAlign = "center";
		ctx.textBaseline = "bottom";
		for (var d = 0; d <= this.dampnessParm.h; d = d + 2) {
			x = this.d2x(d);
			ctx.strokeStyle = this.dampnessParm.StrokeColor;
			//重新定义绘制范围时，先保存下
			ctx.save();
			this.createClip(ctx);//定义绘制范围
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x, y2);
			ctx.stroke();
			ctx.restore();
			//绘制标注
			ctx.font = this.font
			ctx.strokeStyle = this.textcolor;
			ctx.strokeText(d, x, y);
		}
	},
	//这个有问题
	drawPv: function (ctx) {
		var pvmas = psychro_pv2(45 / 1000, this.atm);
		//console.log(pvmas);
		var x;
		for (var pv = 0; pv <= pvmas * 10; pv++) {
			var d = psychro_d2(pv / 10);
			x = this.d2x(d * 1000);
			ctx.beginPath();
			ctx.moveTo(x, this.canvas.height * 0.05);
			ctx.lineTo(x, this.canvas.height * 0.05 + 2);
			ctx.stroke();
			//console.log("x:",x)
			ctx.textAlign = "right";
			ctx.textBaseline = "middle";
			ctx.strokeText(pv, x, this.canvas.height * 0.05 + 2);
		}
	},
	drawMark: function (ctx) {
		ctx.textAlign = "right";
		ctx.textBaseline = "middle";
		ctx.strokeText('大气压:' + this.atm + '(kPa)', this.width / 2, 10);
	},
	
	drawStatus: function (ctx, status1, mark, color, lwidth) {
		var x = this.d2x(status1.d * 1000);
		var y = this.dh2y(status1.d * 1000, status1.h)
		if (mark) {
			ctx.font = '1em Vijaya'
			ctx.strokeStyle = 'black';
			ctx.lineWidth = 1;
			ctx.strokeText(mark, x - 10, y - 10);
		}
		ctx.strokeStyle = color;
		ctx.lineWidth = lwidth;
		ctx.beginPath();

		ctx.arc(x, y, 2, 0, 2 * Math.PI);
		ctx.stroke();
		if(status1.cheked)ctx.fill();
	},
	drawLine: function (ctx, p1, p2, mark, color, lwidth) {
		var x1 = this.d2x(p1.d * 1000);
		var y1 = this.dh2y(p1.d * 1000, p1.h)
		var x2 = this.d2x(p2.d * 1000);
		var y2 = this.dh2y(p2.d * 1000, p2.h)
		var x = (x1 + x2) / 2
		var y = (y1 + y2) / 2
		if (mark) {
			ctx.font = '1em Vijaya'
			ctx.strokeStyle = 'black';
			ctx.lineWidth = 1;
			ctx.strokeText(mark, x, y);
		}

		ctx.strokeStyle = color;
		ctx.lineWidth = lwidth;
		//this.drawArrow(ctx,x1,x2,y1,y2,3)
		ctx.beginPath();
		ctx.moveTo(x1, y1);
		ctx.lineTo(x2, y2);
		ctx.stroke();
	},
	//温度
	T2Points: function (t) {
		var x1, y1, x2, y2;
		var d1, h1, d2, h2;
		var result1, result2;
		result2 = Calcu_04(t, this.dampnessParm.h / 1000, this.atm);
		d2 = result2.d * 1000;//求出含湿量单位g/kg
		h2 = result2.h;//求出焓值(可以认为y轴上的h)
		result1 = Calcu_04(t, 0, this.atm);
		d1 = 0;
		h1 = result1.h;

		//将d,h映射到x,y上
		x1 = this.d2x(d1);;
		y1 = this.dh2y(d1, h1);

		x2 = this.d2x(d2);
		y2 = this.dh2y(d2, h2);
		return {
			p1: { x: x1, y: y1 },
			p2: { x: x2, y: y2 },
			p3: { x: x1 - 5, y: y1 }
		};
	},
	//焓值
	H2points: function (h) {
		var x1, y1, x2, y2;
		var d1, h1, d2, h2;
		var result1, result2;
		result2 = Calcu_45(this.dampnessParm.h / 1000, h, this.atm);
		//console.log("result2:",result2)
		d2 = result2.d * 1000;//求出含湿量单位g/kg
		h2 = result2.h;//求出焓值(可以认为y轴上的h)

		result1 = Calcu_45(0, h, this.atm);
		d1 = result1.d * 1000;
		h1 = result1.h;
		x1 = this.d2x(d1);;
		y1 = this.dh2y(d1, h1);

		x2 = this.d2x(d2);
		y2 = this.dh2y(d2, h2);

		var res3 = Calcu_25(60, h, this.atm);
		var d3 = res3.d * 1000;
		var h3 = res3.h;
		var x3 = this.d2x(d3);
		var y3 = this.dh2y(d3, h3);
		return {
			p1: { x: x1, y: y1 },
			p2: { x: x2, y: y2 },
			p3: { x: x3, y: y3 }
		};
	},
	//湿度
	D2points: function (d) {
		var x1, y1, x2, y2;
		var res1, res2;

		res1 = Calcu_04(this.temperatureParm.h, 0, this.atm);
		res2 = Calcu_04(this.temperatureParm.l, 0, this.atm);
		x1 = this.d2x(d);;
		y1 = this.dh2y(0, res1.h) - 10;
		x2 = x1
		y2 = this.dh2y(0, res2.h) - 10;

		return {
			p1: { x: x1, y: y1 },
			p2: { x: x2, y: y2 },
		};
	},
	//等相对湿度
	RH2points: function (rh) {
		var points = [];
		for (var d = 0.001; d <= this.dampnessParm.h + 0.001; d = d + 2) {
			var result = Calcu_24(rh, d / 1000, this.atm);
			var x = this.d2x(d);;
			var y = this.dh2y(d, result.h);
			points.push({ x: x, y: y });
		}
		return points;
	},
	dh2y: function (d, h) {
		return this.origin_y - (h * this.scale_h * Math.sqrt(2, 2) - d * this.scale_d);
	},
	d2x: function (d) {
		var x = d * this.scale_d + this.origin_x
		//console.log("d:",d,"x:",x)
		return x;
	},
	xy2res: function (x, y) {
		var d = (x - this.origin_x) / this.scale_d;
		var h = (this.origin_y - y + d * this.scale_d) / this.scale_h / Math.sqrt(2, 2);
		return Calcu_45(d / 1000, h, this.atm);
	}

}
export default Chart;


// WEBPACK FOOTER //
// ./src/vue/chart/EHchart.js